import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const videos = [
  { src: '/home/minits.mp4', link: '/minites', anchor: 'minites-top' },
  { src: '/home/branding.mp4', link: '/branding', anchor: 'branding-top' },
  { src: '/home/programing.mp4', link: '/programs', anchor: 'programs-top' },
];

const INTERVAL = 4000;

export default function GifVideosSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const videoRefs = useRef([]);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % videos.length);
    }, INTERVAL);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    videoRefs.current.forEach((video, idx) => {
      if (!video) return;
      if (idx === currentIndex) {
        video.currentTime = 0;
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }, [currentIndex]);

  const handleClick = (item) => {
    navigate(item.link);
    setTimeout(() => {
      const element = document.getElementById(item.anchor);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  return (
    <section style={{
      width: '100vw',
      height: '800px',
      position: 'relative',
      background: '#000',
      overflow: 'hidden',
      margin: 0,
      padding: 0,
      cursor: 'pointer'
    }}>
      {videos.map((item, idx) => (
        <div 
          key={item.src}
          onClick={() => handleClick(item)}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            opacity: idx === currentIndex ? 1 : 0,
            transition: 'opacity 0.8s ease-in-out',
            backgroundColor: '#000'
          }}
        >
          <video
            ref={el => videoRefs.current[idx] = el}
            src={item.src}
            muted
            loop
            playsInline
            preload="auto"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block'
            }}
          />
        </div>
      ))}
    </section>
  );
}
